import { createSlice } from '@reduxjs/toolkit'

// Setup the initial state

const initialState = {
  listPersonalReferences: {},
  insertPersonalReference: {},
  listEconomicReferences: {},
  insertEconomicReference: {},
  deleteEconomicReference: {},
};

export const referencesSlice = createSlice({
  name: 'references',
  initialState,
  reducers: {

    // List Personal References

    setListPersonalReferencesLoading: (state) => {
      state.listPersonalReferences = {
        isLoading: true,
      };
    },

    setListPersonalReferencesSuccess: (state, action) => {
      state.listPersonalReferences = {
        data: action.payload
      };
    },

    setListPersonalReferencesFailure: (state, action) => {
      state.listPersonalReferences = {
        error: action.payload,
      }
    },

    // Insert Personal Reference

    setInsertPersonalReferenceLoading: (state) => {
      state.insertPersonalReference = {
        isLoading: true,
      };
    },

    setInsertPersonalReferenceSuccess: (state) => {
      state.insertPersonalReference = {
        success: true
      };
    },

    setInsertPersonalReferenceFailure: (state, action) => {
      state.insertPersonalReference = {
        error: action.payload,
      }
    },

    clearInsertPersonalReference: (state) => {
      state.insertPersonalReference = {}
    },

    // List Economic References

    setListEconomicReferencesLoading: (state) => {
      state.listEconomicReferences = {
        isLoading: true,
      };
    },

    setListEconomicReferencesSuccess: (state, action) => {
      state.listEconomicReferences = {
        data: action.payload
      };
    },

    setListEconomicReferencesFailure: (state, action) => {
      state.listEconomicReferences = {
        error: action.payload,
      }
    },

    // Insert Economic Reference

    setInsertEconomicReferenceLoading: (state) => {
      state.insertEconomicReference = {
        isLoading: true,
      };
    },

    setInsertEconomicReferenceSuccess: (state) => {
      state.insertEconomicReference = {
        success: true
      };
    },

    setInsertEconomicReferenceFailure: (state, action) => {
      state.insertEconomicReference = {
        error: action.payload,
      }
    },

    clearInsertEconomicReference: (state) => {
      state.insertEconomicReference = {}
    },
    
    // Delete Economic Reference

    setDeleteEconomicReferenceLoading: (state) => {
      state.deleteEconomicReference = {
        isLoading: true,
      };
    },

    setDeleteEconomicReferenceSuccess: (state) => {
      state.deleteEconomicReference = {
        success: true
      };
    },

    setDeleteEconomicReferenceFailure: (state, action) => {
      state.deleteEconomicReference = {
        error: action.payload,
      }
    },

    clearDeleteEconomicReference: (state) => {
      state.deleteEconomicReference = {}
    },

  },
})

export const {
  setListPersonalReferencesLoading, setListPersonalReferencesSuccess, setListPersonalReferencesFailure,
  setInsertPersonalReferenceLoading, setInsertPersonalReferenceSuccess, setInsertPersonalReferenceFailure, clearInsertPersonalReference,
  setListEconomicReferencesLoading, setListEconomicReferencesSuccess, setListEconomicReferencesFailure,
  setInsertEconomicReferenceLoading, setInsertEconomicReferenceSuccess, setInsertEconomicReferenceFailure, clearInsertEconomicReference,
  setDeleteEconomicReferenceLoading, setDeleteEconomicReferenceSuccess, setDeleteEconomicReferenceFailure, clearDeleteEconomicReference,
} = referencesSlice.actions

export default referencesSlice.reducer;